<template>
  <div class="wrapper df fdr fww">
    <h2 class="w100p">Project Phases</h2>

    <div class="w100p">
      <p v-if="editingPhases" v-on:click="editPhases(false)" class="w100p df jcfe edit-toggle general-hover">Done Edits</p>
      <p v-else v-on:click="editPhases(true)" class="w100p df edit-toggle jcfe general-hover">Edit Phases</p>
      <span class="all-phases df fww">

        <span v-for="(phase, key) in $store.getters.currentProjectPhases"
              class="phase-box box df fdc posrel">
          <p v-on:click="deletePhase(key)" v-if="editingPhases && $store.getters.currentProjectPhases.length > 1" class="delete-phase df aic jcc">
            -
          </p>
          <span class="info-top">
            <input class="phase-name-input" v-if="editingPhases" type="text" v-bind:value="phase.name" @change="editNewPhaseName(key, $event)"/>
            <p v-else>
              {{ phase.name }}
            </p>
          </span>
          <span class="task-list">
            <p v-if="(!phase.list || (phase.list.length == 0)) &&
            (!phase.list2 || (phase.list2.length == 0)) &&
            (!phase.list3 || (phase.list3.length == 0))">
              No tasks
            </p>




            <p v-for="(task, key2) in phase.list" class="task-list-item df jcfs aic posrel">
              <span class="delete-task df aic jcc"
                v-if="editingPhases"
                v-on:click="removeThisTaskFromPhase(key2, key)"
              >
                <img src="/images/Trash.svg" class="delete-task-svg general-hover"/>
              </span>
              <span v-on:click="setEditingTaskPercent(key + '-' + key2 + '-1', task, 1)"
                class="df jcfs aic general-hover f1"
                v-bind:class="{ 'editingThisTaskNow': editingTask === task[0] + '-1' }"
              >
                <span class="f1 general-hover">
                  {{ $store.getters.currentProjectModuleColumns.hourlyElements[task[0]].name }}
                </span>
                <span class="fz20 general-hover">
                  {{ task[1] || 0 }} %
                </span>
              </span>
              <span v-if="editTaskPercent == key + '-' + key2 + '-1'" class="addTaskMenu editPercentMenu box">
                <p class='fw500'>
                  {{ $store.getters.currentProjectModuleColumns.hourlyElements[task[0]].name }}
                </p>
                <p v-for="(phaseInner, key3) in $store.getters.currentProjectPhases">
                  <span class="df jcfe taskRowItem"
                    v-bind:class="{
                      'editingThisTaskNow': key == key3,
                      'phase-doesnt-have-task': !(phaseInner.list && phaseInner.list.filter(v => v[0] == task[0])[0])
                    }"
                  >
                    <p class="f1">
                      {{ phaseInner.name }}
                    </p>
                    <!-- <p class="df" v-if="key == key3"> -->
                      <input class="phase-percent-edit" type="number" @change="editPhasePercentValue(key3, $event)" v-bind:value="editPhasePercent[key3] || (phaseInner.list ? (phaseInner.list.filter(v => v[0] == task[0])[0] ? phaseInner.list.filter(v => v[0] == task[0])[0][1] : 0) : 0)"/> %
                    <!-- </p> -->
                      <!-- <p v-else>
                        {{ phaseInner.list ? (phaseInner.list.filter(v => v[0] == task[0])[0] ? phaseInner.list.filter(v => v[0] == task[0])[0][1] : 0) : 0 }} %
                      </p> -->
                  </span>
                </p>
                <p>
                  <span class="df jcsb"
                    v-bind:class="{ 'animated fadeIn': animateTotal}"
                  >
                    <p>
                      Total
                    </p>
                    <p>
                      {{ totalPercentForPhases(task) }} %
                    </p>
                  </span>
                </p>
                <span class="df jcsb p20">
                  <p class="general-hover" v-on:click="setEditingTaskPercent(false)">
                    Close
                  </p>
                  <p class="general-hover" v-on:click="saveEditingPercent(task)">
                    Save
                  </p>
                </span>
              </span>
            </p>





            <p v-for="(task, key2) in phase.list2" class="task-list-item df jcfs aic posrel">
              <span class="delete-task df aic jcc"
                v-if="editingPhases"
                v-on:click="removeThisTaskFromPhase2(key2, key)"
              >
                <img src="/images/Trash.svg" class="delete-task-svg general-hover"/>
              </span>
              <span v-on:click="setEditingTaskPercent(key + '-' + key2 + '-2', task, 2)"
                class="df jcfs aic general-hover f1"
                v-bind:class="{ 'editingThisTaskNow': editingTask === task[0] + '-2' }"
              >
                <span class="f1 general-hover">
                  {{ $store.getters.currentProjectModuleColumns.percentTasks[task[0]].name }}
                </span>
                <span class="fz20 general-hover">
                  {{ task[1] || 0 }} %
                </span>
              </span>
              <span v-if="editTaskPercent == key + '-' + key2 + '-2'" class="addTaskMenu editPercentMenu box">
                <p class='fw500'>
                  {{ $store.getters.currentProjectModuleColumns.percentTasks[task[0]].name }}
                </p>
                <p v-for="(phaseInner, key3) in $store.getters.currentProjectPhases">
                  <span class="df jcfe taskRowItem"
                    v-bind:class="{
                      'editingThisTaskNow': key == key3,
                      'phase-doesnt-have-task': !(phaseInner.list2 && phaseInner.list2.filter(v => v[0] == task[0])[0])
                    }"
                  >
                    <p class="f1">
                      {{ phaseInner.name }}
                    </p>
                    <!-- <p class="df" v-if="key == key3"> -->
                      <input class="phase-percent-edit" type="number" @change="editPhasePercentValue2(key3, $event)" v-bind:value="editPhasePercent2[key3] || (phaseInner.list2 ? (phaseInner.list2.filter(v => v[0] == task[0])[0] ? phaseInner.list2.filter(v => v[0] == task[0])[0][1] : 0) : 0)"/> %
                    <!-- </p> -->
                      <!-- <p v-else>
                        {{ phaseInner.list ? (phaseInner.list.filter(v => v[0] == task[0])[0] ? phaseInner.list.filter(v => v[0] == task[0])[0][1] : 0) : 0 }} %
                      </p> -->
                  </span>
                </p>
                <p>
                  <span class="df jcsb"
                    v-bind:class="{ 'animated fadeIn': animateTotal2}"
                  >
                    <p>
                      Total
                    </p>
                    <p>
                      {{ totalPercentForPhases2(task) }} %
                    </p>
                  </span>
                </p>
                <span class="df jcsb p20">
                  <p class="general-hover" v-on:click="setEditingTaskPercent(false)">
                    Close
                  </p>
                  <p class="general-hover" v-on:click="saveEditingPercent2(task)">
                    Save
                  </p>
                </span>
              </span>
            </p>




            <p v-for="(task, key2) in phase.list3" class="task-list-item df jcfs aic posrel">
              <span class="delete-task df aic jcc"
                v-if="editingPhases"
                v-on:click="removeThisTaskFromPhase3(key2, key)"
              >
                <img src="/images/Trash.svg" class="delete-task-svg general-hover"/>
              </span>
              <span v-on:click="setEditingTaskPercent(key + '-' + key2 + '-3', task, 3)"
                class="df jcfs aic general-hover f1"
                v-bind:class="{ 'editingThisTaskNow': editingTask === task[0] + '-3' }"
              >
                <span class="f1 general-hover">
                  {{ $store.getters.currentProjectModuleColumns.fixedElements[task[0]].name }}
                </span>
                <span class="fz20 general-hover">
                  {{ task[1] || 0 }} %
                </span>
              </span>
              <span v-if="editTaskPercent == key + '-' + key2 + '-3'" class="addTaskMenu editPercentMenu box">
                <p class='fw500'>
                  {{ $store.getters.currentProjectModuleColumns.fixedElements[task[0]].name }}
                </p>
                <p v-for="(phaseInner, key3) in $store.getters.currentProjectPhases">
                  <span class="df jcfe taskRowItem"
                    v-bind:class="{
                      'editingThisTaskNow': key == key3,
                      'phase-doesnt-have-task': !(phaseInner.list3 && phaseInner.list3.filter(v => v[0] == task[0])[0])
                    }"
                  >
                    <p class="f1">
                      {{ phaseInner.name }}
                    </p>
                    <!-- <p class="df" v-if="key == key3"> -->
                      <input class="phase-percent-edit" type="number" @change="editPhasePercentValue3(key3, $event)" v-bind:value="editPhasePercent3[key3] || (phaseInner.list3 ? (phaseInner.list3.filter(v => v[0] == task[0])[0] ? phaseInner.list3.filter(v => v[0] == task[0])[0][1] : 0) : 0)"/> %
                    <!-- </p> -->
                      <!-- <p v-else>
                        {{ phaseInner.list ? (phaseInner.list.filter(v => v[0] == task[0])[0] ? phaseInner.list.filter(v => v[0] == task[0])[0][1] : 0) : 0 }} %
                      </p> -->
                  </span>
                </p>
                <p>
                  <span class="df jcsb"
                    v-bind:class="{ 'animated fadeIn': animateTotal3}"
                  >
                    <p>
                      Total
                    </p>
                    <p>
                      {{ totalPercentForPhases3(task) }} %
                    </p>
                  </span>
                </p>
                <span class="df jcsb p20">
                  <p class="general-hover" v-on:click="setEditingTaskPercent(false)">
                    Close
                  </p>
                  <p class="general-hover" v-on:click="saveEditingPercent3(task)">
                    Save
                  </p>
                </span>
              </span>
            </p>




          </span>
          <span v-if="editingPhases" v-on:click="addTaskToPhase(key)">
            <p class="general-hover">
              + Add Task
            </p>
          </span>
          <div v-if="addingTaskToPhase === key" class="addTaskMenu box">
            <p v-on:click="addTaskToPhase(key)" class="add-task-menu-header df fdc info-top">
              Add Task
            </p>
            <p v-if="allTasksAdded(phase)" class="o65">All tasks added</p>
            <p v-for="(task, key2) in $store.getters.currentProjectModuleColumns.hourlyElements"
                v-if="!phase.list || (phase.list.filter(v => v[0] == key2).length == 0)"
                v-on:click="addThisTaskToPhase(key2, key)"
                class="general-hover"
            >
              {{ task.name }}
            </p>
            <p v-for="(task, key2) in $store.getters.currentProjectModuleColumns.percentTasks"
                v-if="!phase.list2 || (phase.list2.filter(v => v[0] == key2).length == 0)"
                v-on:click="addThisTaskToPhase2(key2, key)"
                class="general-hover"
            >
              {{ task.name }}
            </p>
            <p v-for="(task, key2) in $store.getters.currentProjectModuleColumns.fixedElements"
                v-if="!phase.list3 || (phase.list3.filter(v => v[0] == key2).length == 0)"
                v-on:click="addThisTaskToPhase3(key2, key)"
                class="general-hover"
            >
              {{ task.name }}
            </p>
            <p v-on:click="stopAddingTaskToPhase()" class="pt20 df jcfs aic general-hover">
              <img src="/images/Remove.svg" class="delete-task-svg"/>
              <span class="general-hover">Close</span>
            </p>
          </div>
        </span>

      </span>

    </div>

    <h2 class="w100p">Unallocated Tasks</h2>
    <div class="w100p">
      <span v-for="(task, id) in $store.getters.currentProjectModuleColumns.hourlyElements" class="df fdr aic phase-box phase-box2">
        <p>
          {{ task.name }}
        </p>
        <p class="fz20"
          v-bind:class="{
            'editingThisTaskNow': unallocatedPercentForTask(id) > 0,
            'fullyAllocatedTask': unallocatedPercentForTask(id) === 0
          }"
        >
          {{ unallocatedPercentForTask(id) }} %
        </p>
      </span>
      <span v-for="(task, id) in $store.getters.currentProjectModuleColumns.percentTasks" class="df fdr aic phase-box phase-box2">
        <p>
          {{ task.name }}
        </p>
        <p class="fz20"
          v-bind:class="{
            'editingThisTaskNow': unallocatedPercentForTask2(id) > 0,
            'fullyAllocatedTask': unallocatedPercentForTask2(id) === 0
          }"
        >
          {{ unallocatedPercentForTask2(id) }} %
        </p>
      </span>
      <span v-for="(task, id) in $store.getters.currentProjectModuleColumns.fixedElements" class="df fdr aic phase-box phase-box2">
        <p>
          {{ task.name }}
        </p>
        <p class="fz20"
          v-bind:class="{
            'editingThisTaskNow': unallocatedPercentForTask3(id) > 0,
            'fullyAllocatedTask': unallocatedPercentForTask3(id) === 0
          }"
        >
          {{ unallocatedPercentForTask3(id) }} %
        </p>
      </span>
    </div>
  </div>
</template>


<script>
// import ProjectTask from '../components/ProjectTask'
export default {
  name: 'ProjectPagePhases',
  data () {
    return {
      newPhaseName: null,
      selectedPriceRange: 'mid',
      addingTaskToPhase: false,
      editingPhases: false,
      editingTask: false,
      editTaskPercent: false,
      editPhasePercent: {},
      editPhasePercent2: {},
      editPhasePercent3: {},
      animateTotal: false,
      animateTotal2: false,
      animateTotal3: false
    }
  },
  props: [],
  components: {
    // ProjectTask
  },
  methods: {
    allTasksAdded (phase) {
      var allAdded = true
      if (phase.list) {
        if (phase.list.length !== this.$store.getters.currentProjectModuleColumns.hourlyElements.length) {
          allAdded = false
        }
      } else {
        allAdded = false
      }
      if (phase.list2) {
        if (phase.list2.length !== this.$store.getters.currentProjectModuleColumns.percentTasks.length) {
          allAdded = false
        }
      } else {
        allAdded = false
      }
      if (phase.list3) {
        if (phase.list3.length !== this.$store.getters.currentProjectModuleColumns.fixedElements.length) {
          allAdded = false
        }
      } else {
        allAdded = false
      }
      return allAdded
    },
    unallocatedPercentForTask (id) {
      var percentTotal = 0
      var phases = this.$store.getters.currentProjectPhases
      for (var phase in phases) {
        // console.log('phases[phase]', phases[phase])
        // console.log('phase', phases[phase].list)
        if (phases[phase].list) {
          for (var task in phases[phase].list) {
            if (phases[phase].list[task][0] == id) {
              percentTotal = parseFloat(percentTotal) + parseFloat(phases[phase].list[task][1])
            }
          }
        }
      }
      return 100 - percentTotal
      // this.$store.getters.currentProjectModuleColumns.hourlyElements
    },
    unallocatedPercentForTask2 (id) {
      var percentTotal = 0
      var phases = this.$store.getters.currentProjectPhases
      for (var phase in phases) {
        // console.log('phases[phase]', phases[phase])
        console.log('phase', phases[phase].list)
        if (phases[phase].list2) {
          for (var task in phases[phase].list2) {
            if (phases[phase].list2[task][0] == id) {
              percentTotal = parseFloat(percentTotal) + parseFloat(phases[phase].list2[task][1])
            }
          }
        }
      }
      return 100 - percentTotal
      // this.$store.getters.currentProjectModuleColumns.hourlyElements
    },
    unallocatedPercentForTask3 (id) {
      var percentTotal = 0
      var phases = this.$store.getters.currentProjectPhases
      for (var phase in phases) {
        // console.log('phases[phase]', phases[phase])
        console.log('phase', phases[phase].list3)
        if (phases[phase].list3) {
          for (var task in phases[phase].list3) {
            if (phases[phase].list3[task][0] == id) {
              percentTotal = parseFloat(percentTotal) + parseFloat(phases[phase].list3[task][1])
            }
          }
        }
      }
      return 100 - percentTotal
      // this.$store.getters.currentProjectModuleColumns.hourlyElements
    },
    deletePhase (phase) {
      var phases = this.$store.getters.currentProjectPhases
      if (phases.length == 1) {
        return false
      }
      var data = {
        phase,
        phases,
        projectid: this.$route.params.projectid
      }
      console.log('deletePhase')
      this.$store.dispatch('deletePhase', data).then(() => {
        console.log('after deletePhase')
      })
    },
    editNewPhaseName (phase, event) {
      var text = event.target.value
      var data = {
        text,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('editPhaseName', text)
      this.$store.dispatch('editPhaseName', data).then(() => {
        console.log('after editPhaseName')
      })
    },
    totalPercentForPhases (task) {
      console.log()
      var phases = this.$store.getters.currentProjectPhases
      var total = 0
      for (var phase in phases) {
        if (phases[phase].list) {
          if (phases[phase].list.filter(v => v[0] == task[0])[0]) {
            if (this.editPhasePercent[phase]) {
              total = parseFloat(total) + parseFloat(this.editPhasePercent[phase])
            } else {
              total = parseFloat(total) + parseFloat(phases[phase].list.filter(v => v[0] == task[0])[0][1])
            }
          } else {
            //
          }
        } else {
          //
        }
      }
      return total
    },
    totalPercentForPhases2 (task) {
      console.log()
      var phases = this.$store.getters.currentProjectPhases
      var total = 0
      for (var phase in phases) {
        if (phases[phase].list2) {
          if (phases[phase].list2.filter(v => v[0] == task[0])[0]) {
            if (this.editPhasePercent2[phase]) {
              total = parseFloat(total) + parseFloat(this.editPhasePercent2[phase])
            } else {
              total = parseFloat(total) + parseFloat(phases[phase].list2.filter(v => v[0] == task[0])[0][1])
            }
          } else {
            //
          }
        } else {
          //
        }
      }
      return total
    },
    totalPercentForPhases3 (task) {
      console.log()
      var phases = this.$store.getters.currentProjectPhases
      var total = 0
      for (var phase in phases) {
        if (phases[phase].list3) {
          if (phases[phase].list3.filter(v => v[0] == task[0])[0]) {
            if (this.editPhasePercent3[phase]) {
              total = parseFloat(total) + parseFloat(this.editPhasePercent3[phase])
            } else {
              total = parseFloat(total) + parseFloat(phases[phase].list3.filter(v => v[0] == task[0])[0][1])
            }
          } else {
            //
          }
        } else {
          //
        }
      }
      return total
    },
    flashThisTotal () {
      this.animateTotal = true
      setTimeout(() => {
        this.animateTotal = false
      }, 1000)
    },
    flashThisTotal2 () {
      this.animateTotal2 = true
      setTimeout(() => {
        this.animateTotal = false
      }, 1000)
    },
    flashThisTotal3 () {
      this.animateTotal3 = true
      setTimeout(() => {
        this.animateTotal = false
      }, 1000)
    },
    saveEditingPercent (taskId) {
      // totalPercentForPhases
      if (this.totalPercentForPhases(taskId) > 100) {
        this.flashThisTotal()
        return
      }
      var phases = this.$store.getters.currentProjectPhases
      for (var index in this.editPhasePercent) {
        var i = phases[index].list.filter(v => v[0] == taskId[0])[0]
        i = phases[index].list.indexOf(i)
        phases[index].list[i][1] = this.editPhasePercent[index]
      }

      var data = {
        phases,
        projectid: this.$route.params.projectid
      }
      this.$store.dispatch('savePhases', data).then(() => {
        this.setEditingTaskPercent(false)
        this.editPhasePercent = {}
      })
    },
    saveEditingPercent2 (taskId) {
      // totalPercentForPhases
      if (this.totalPercentForPhases(taskId) > 100) {
        this.flashThisTotal2()
        return
      }
      var phases = this.$store.getters.currentProjectPhases
      for (var index in this.editPhasePercent2) {
        var i = phases[index].list2.filter(v => v[0] == taskId[0])[0]
        i = phases[index].list2.indexOf(i)
        phases[index].list2[i][1] = this.editPhasePercent2[index]
      }

      var data = {
        phases,
        projectid: this.$route.params.projectid
      }
      this.$store.dispatch('savePhases', data).then(() => {
        this.setEditingTaskPercent(false)
        this.editPhasePercent2 = {}
      })
    },
    saveEditingPercent3 (taskId) {
      // totalPercentForPhases
      if (this.totalPercentForPhases(taskId) > 100) {
        this.flashThisTotal3()
        return
      }
      var phases = this.$store.getters.currentProjectPhases
      for (var index in this.editPhasePercent3) {
        var i = phases[index].list3.filter(v => v[0] == taskId[0])[0]
        i = phases[index].list3.indexOf(i)
        phases[index].list3[i][1] = this.editPhasePercent3[index]
      }

      var data = {
        phases,
        projectid: this.$route.params.projectid
      }
      this.$store.dispatch('savePhases', data).then(() => {
        this.setEditingTaskPercent(false)
        this.editPhasePercent3 = {}
      })
    },
    editPhasePercentValue (index, event) {
      console.log('event', event.target.value);
      this.editPhasePercent[index] = event.target.value;
      this.editPhasePercent = {...this.editPhasePercent}
    },
    editPhasePercentValue2 (index, event) {
      console.log('event2', event.target.value);
      this.editPhasePercent2[index] = event.target.value;
      this.editPhasePercent2 = {...this.editPhasePercent2}
    },
    editPhasePercentValue3 (index, event) {
      console.log('event3', event.target.value);
      this.editPhasePercent3[index] = event.target.value;
      this.editPhasePercent3 = {...this.editPhasePercent3}
    },
    setEditingTaskPercent(value, task, listId) {
      console.log('setEditingTaskPercent', value, task, listId)
      if (this.editingPhases) {
        this.editTaskPercent = value
        if (task) {
          if (task[0] === 0) {
            this.editingTask = 0 + (listId && '-' + listId)
          } else {
            this.editingTask = task[0] + (listId && '-' + listId)
          }
        } else {
          this.editingTask = false
        }
      }
    },
    addThisTaskToPhase (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('addThisTaskToPhase')
      this.$store.dispatch('addTaskToPhase', data).then(() => {
        console.log('after addTaskToPhase')
      })
    },
    addThisTaskToPhase2 (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('addTaskToPhase2')
      this.$store.dispatch('addTaskToPhase2', data).then(() => {
        console.log('after addTaskToPhase2')
      })
    },
    addThisTaskToPhase3 (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('addTaskToPhase3')
      this.$store.dispatch('addTaskToPhase3', data).then(() => {
        console.log('after addTaskToPhase3')
      })
    },
    removeThisTaskFromPhase (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('removeThisTaskFromPhase')
      this.$store.dispatch('removeTaskFromPhase', data).then(() => {
        console.log('after removeThisTaskFromPhase')
      })
    },
    removeThisTaskFromPhase2 (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('removeThisTaskFromPhase2')
      this.$store.dispatch('removeTaskFromPhase2', data).then(() => {
        console.log('after removeThisTaskFromPhase2')
      })
    },
    removeThisTaskFromPhase3 (task, phase) {
      var data = {
        task,
        phase,
        projectid: this.$route.params.projectid
      }
      console.log('removeThisTaskFromPhase3')
      this.$store.dispatch('removeTaskFromPhase3', data).then(() => {
        console.log('after removeThisTaskFromPhase3')
      })
    },
    addTaskToPhase (phase) {
      this.addingTaskToPhase = phase
    },
    stopAddingTaskToPhase () {
      this.addingTaskToPhase = false
    },
    editPhases (status) {
      if (!status) {
        this.stopAddingTaskToPhase();
      }
      this.editingPhases = status
    }
  },
  computed: {

  },
  created () {
    console.log('** Phases Component Loaded1', this.$store.getters.currentProjectName)
    console.log('** Phases Component Loaded', this.$store.getters.currentProjectPhases)
  }
}
</script>

<style scoped lang="scss">
h2 {
  color: black;
  margin-bottom: 20px;
}
.wrapper {
  transform: translateY(134px);
  padding: 40px;
}

.w50 {
  width: 50%;
}

.p20 {
  padding: 20px;
}

.phase-box {
  width: 250px;
  margin-right: 20px;
  justify-content: space-between;
  margin-bottom: 40px;

  & > span {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;

    &:first-of-type {
      padding-top: 20px;
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: 500;
    }

    &:nth-of-type(2) {
      padding-top: 20px;
    }

    &:nth-last-of-type(2) {
      padding-bottom: 0;
    }

    &:last-of-type {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
}

.phase-box2 {
  margin-bottom: 10px;
}

.addTaskMenu {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  background-color: white;
  width: 200px;
  z-index: 2000;

  & > p {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;

    &:first-child {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    &:nth-child(2) {
      padding-top: 20px;
      /*padding-bottom: 0;*/
    }
    &:last-child {
      padding-bottom: 20px;
    }
  }
}

.editPercentMenu {
  left: calc(100% - 20px);
  & > p {
    &:first-child {
    }
    &:nth-child(2) {
      padding-top: 0;
    }
    &:last-child {
    }
  }
}

.info-top {
  /*border-radius: 9px 9px 0 0;*/
  background-color: #D9EDFF;
  padding-bottom: 20px !important;
}

.delete-task {
  width: 20px;
}

.delete-task-svg {
  width: 20px;
  margin-right: 10px;
}

.pt20 {
  padding-top: 20px;
}

.o65 {
  opacity: .65;
}

.taskMenu {
  position: absolute;
  right: 10px;
  top: 50%;
  padding: 20px;
  z-index: 2000;
}

.task-list {
  flex: 1;
}

.taskRowItem {
  color: red;
  input {
    color: red;
  }
}

.editingThisTaskNow {
  color: red;
}

.phase-percent-edit {
  font-family: 'Roboto', sans-serif;
  width: 45px;
  text-align: end;
  font-size: 16px;
  border: none;
  background-color: transparent;
}

.phase-doesnt-have-task {
  pointer-events: none;
  opacity: 0.6;
  color: black;
  input {
    color: black;
  }
}

.example-enter {
  opacity: 0.01;
}

.example-enter.example-enter-active {
  opacity: 1;
  transition: opacity 500ms ease-in;
}

.example-leave {
  opacity: 1;
}

.example-leave.example-leave-active {
  opacity: 0.01;
  transition: opacity 300ms ease-in;
}

.animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
 }

@keyframes fadeIn {
    0% {
        opacity: 0;
        background-color: blue;
        color: white;
    }
    100% {
        opacity: 1;
        background-color: transparent;
    }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.phase-name-input {
  font-size: 20px;
  border: none;
  background-color: transparent;
}

.delete-phase {
  color: white;
  font-size: 34px;
  font-weight: 500;
  line-height: 1em;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  border-radius: 50%;
  height: 30px;
  width: 30px;
  background-color: red;
}

.fullyAllocatedTask {
  position: relative;
  &::after {
    content: '✔';
    position: absolute;
    left: calc(100% + 15px);
  }
}
.edit-toggle {
  color: #0874D8;
  text-transform: uppercase;
  font-weight: 500;
}
</style>
